//
import React, { ReactNode } from 'react';
import { StyleProp, StyleSheet, Text, TextStyle, ViewStyle } from 'react-native';
import colors from '../../colors';
import { TXT_M } from '../../constants';
import Touchable from './Touchable';

type Props = {
  onPress: () => void;
  title: string;
  backgroundColor?: string;
  style?: StyleProp<ViewStyle>;
  labelStyle?: StyleProp<TextStyle>;

  icon?: ReactNode;
  // iconName: string;
  // iconColor?: string;
  // iconType?: string;
};

const Button: React.FC<Props> = (props) => {
  const { backgroundColor, onPress, title, style, labelStyle, icon } = props;

  return (
    <Touchable
      style={[
        styles.button,
        { backgroundColor: backgroundColor ? backgroundColor : colors.button },
        style
      ]}
      onPress={onPress}
    >
      {icon ?? false}
      {/* <Icon name={iconName} color={iconColor ? iconColor : '#fff'} type={iconType} /> */}
      <Text style={[styles.txtButton, labelStyle]}>{title}</Text>
    </Touchable>
  );
};

const styles = StyleSheet.create({
  button: {
    padding: 10,
    paddingRight: 20,
    paddingLeft: 20,
    width: '100%',
    borderRadius: 7,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row'
  },
  txtButton: {
    fontSize: TXT_M,
    color: '#fff',
    textAlign: 'center'
  }
});

export default Button;
